export enum TrackingConsentStatus {
  AUTHORIZED = 'authorized',
  DENIED = 'denied',
  // TODO: add if we implement permissions.
  // NOT_DETERMINED = 'notDetermined',
}
